/* bsb-bundle-builder.js
   Drives the bundle configurator (bundle_mode: true).
   Reads config from #bsb-product-data island + #bsb-bundle-tier data-* attrs.
   Does not share scope with bsb-product-info.js. */

(function () {
    'use strict'

    const dataEl = document.getElementById('bsb-product-data')
    if (!dataEl) return

    let data
    try
    {
        data = JSON.parse(dataEl.textContent)
    } catch (e)
    {
        console.warn('[bsb-bb] Failed to parse product data island:', e)
        return
    }

    const variants = data.variants || []
    const highVariantMode = !!data.highVariantMode
    const colorPos = data.colorPos != null ? data.colorPos + 1 : null
    const sizePos = data.sizePos != null ? data.sizePos + 1 : null
    const sportPos = data.sportPos != null ? data.sportPos + 1 : null
    const planetPos = data.planetPos != null ? data.planetPos + 1 : null
    const printPos = data.printPos != null ? data.printPos + 1 : null
    const letterPos = data.letterPos != null ? data.letterPos + 1 : null
    const lineColorPos = data.lineColorPos != null ? data.lineColorPos + 1 : null
    const pumpPos = data.pumpPos != null ? data.pumpPos + 1 : null
    const bundleMin = data.bundleMin

    /* Tier config from the DOM (single source of truth) — static per section render,
       doesn't change across a high-variant refetch, so this stays const. */
    let tierEl = document.getElementById('bsb-bundle-tier')
    const t1Threshold = tierEl ? parseInt(tierEl.dataset.tier1Threshold, 10) : null
    const t1Pct = tierEl ? parseInt(tierEl.dataset.tier1Pct, 10) : null
    const t1Label = tierEl ? tierEl.dataset.tier1Label : null
    const t1Unlocked = tierEl ? tierEl.dataset.tier1Unlocked : null
    const t2Threshold = tierEl ? parseInt(tierEl.dataset.tier2Threshold, 10) : null
    const t2Pct = tierEl ? parseInt(tierEl.dataset.tier2Pct, 10) : null
    const t2Label = tierEl ? tierEl.dataset.tier2Label : null
    const t2Unlocked = tierEl ? tierEl.dataset.tier2Unlocked : null

    /* ── DOM refs ────────────────────────────────────────────────────── */
    /* All of the below live inside #bsb-configurator, so in high-variant mode
       they go stale after refetchConfigurator() swaps its innerHTML — see
       requeryBundleRefs(), called on the bsb:configurator-refreshed event. */

    let qtyMinusBtn = document.getElementById('bsb-qty-minus')
    let qtyPlusBtn = document.getElementById('bsb-qty-plus')
    let qtyValueEl = document.getElementById('bsb-qty-value')
    let addBtn = document.getElementById('bsb-add-to-bundle')
    let bundleListEl = document.getElementById('bsb-bundle-list')
    let bundleCountEl = document.getElementById('bsb-bundle-count')
    let tierCountEl = document.getElementById('bsb-tier-count')
    let tierNextEl = document.getElementById('bsb-tier-next')
    let tierFillEl = tierEl ? tierEl.querySelector('.bsb-bt__fill') : null
    let tierTrackEl = tierEl ? tierEl.querySelector('.bsb-bt__track') : null
    let subtotalEl = document.getElementById('bsb-subtotal')
    let discountRowEl = document.getElementById('bsb-discount-row')
    let discountLblEl = document.getElementById('bsb-discount-label')
    let discountValEl = document.getElementById('bsb-discount-value')
    let totalEl = document.getElementById('bsb-total')
    let totalsEl = document.getElementById('bsb-totals')
    let atcBtn = document.getElementById('bsb-bundle-atc')
    let atcLabelEl = document.getElementById('bsb-atc-label')
    let atcPriceEl = document.getElementById('bsb-atc-price')
    let colorNameEl = document.getElementById('bsb-color-name')
    let sizeNameEl = document.getElementById('bsb-size-name')
    let tipEl = document.getElementById('bsb-size-tooltip')
    let tipTitleEl = document.getElementById('bsb-size-tip-title')
    let tipBestEl = document.getElementById('bsb-size-tip-best')

    function requeryBundleRefs() {
        tierEl = document.getElementById('bsb-bundle-tier')
        qtyMinusBtn = document.getElementById('bsb-qty-minus')
        qtyPlusBtn = document.getElementById('bsb-qty-plus')
        qtyValueEl = document.getElementById('bsb-qty-value')
        addBtn = document.getElementById('bsb-add-to-bundle')
        bundleListEl = document.getElementById('bsb-bundle-list')
        bundleCountEl = document.getElementById('bsb-bundle-count')
        tierCountEl = document.getElementById('bsb-tier-count')
        tierNextEl = document.getElementById('bsb-tier-next')
        tierFillEl = tierEl ? tierEl.querySelector('.bsb-bt__fill') : null
        tierTrackEl = tierEl ? tierEl.querySelector('.bsb-bt__track') : null
        subtotalEl = document.getElementById('bsb-subtotal')
        discountRowEl = document.getElementById('bsb-discount-row')
        discountLblEl = document.getElementById('bsb-discount-label')
        discountValEl = document.getElementById('bsb-discount-value')
        totalEl = document.getElementById('bsb-total')
        totalsEl = document.getElementById('bsb-totals')
        atcBtn = document.getElementById('bsb-bundle-atc')
        atcLabelEl = document.getElementById('bsb-atc-label')
        atcPriceEl = document.getElementById('bsb-atc-price')
        colorNameEl = document.getElementById('bsb-color-name')
        sizeNameEl = document.getElementById('bsb-size-name')
        tipEl = document.getElementById('bsb-size-tooltip')
        tipTitleEl = document.getElementById('bsb-size-tip-title')
        tipBestEl = document.getElementById('bsb-size-tip-best')
    }

    if (highVariantMode)
    {
        document.addEventListener('bsb:configurator-refreshed', function () {
            requeryBundleRefs()
            bindQtyButtons()
            bindAddButton()
            bindBundleList()
            bindAtcButton()
            updateAtcPrice()
        })
    }

    const BALL_WIDTHS = [400, 600, 900, 1200]

    /* ── State ───────────────────────────────────────────────────────── */

    let qty = 1
    let prevDiscountPct = 0
    const bundle = []   /* [{ variantId, color, size, qty, price, swatch }] */

    /* ── Helpers ─────────────────────────────────────────────────────── */

    function escapeHtml(s) {
        if (!s) return ''
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
    }

    function formatPrice(cents) {
        const amount = cents / 100
        return '$' + amount.toLocaleString(undefined, {
            minimumFractionDigits: amount % 1 !== 0 ? 2 : 0,
            maximumFractionDigits: 2,
        })
    }

    function totalBalls() {
        return bundle.reduce((s, i) => s + i.qty, 0)
    }

    function subtotal() {
        return bundle.reduce((s, i) => s + i.price * i.qty, 0)
    }

    function discountPct() {
        if (!tierEl) return 0
        const n = totalBalls()
        if (t2Pct > 0 && n >= t2Threshold) return t2Pct / 100
        if (n >= t1Threshold) return t1Pct / 100
        return 0
    }

    // The single reusable function
    function getActiveInput(category) {
        return document.querySelector(`input[name="bsb-${category}"]:checked`)
    }

    // How you call them whenever you need the active element:
    const activeColor = () => getActiveInput('color')
    const activeSize = () => getActiveInput('size')
    const activeSport = () => getActiveInput('sport')
    const activePlanet = () => getActiveInput('planet')
    const activePrint = () => getActiveInput('print')
    const activeLetter = () => getActiveInput('letter')
    const activeLineColor = () => getActiveInput('line-color')
    const activePump = () => getActiveInput('pump')

    function activeExtraInputs() {
        return Array.from(document.querySelectorAll('input[name^="bsb-opt-"]:checked'))
    }

    function extraPosFromInputName(name) {
        const n = parseInt(name.slice('bsb-opt-'.length), 10)
        return Number.isFinite(n) ? n + 1 : null
    }


    function swatchStyleFor(colorInput, sportInput, planetInput, printInput, letterInput, lineColorInput) {
        if (colorInput)
        {
            const composed = colorInput.getAttribute('data-swatch')
            if (composed) return composed

            const img = colorInput.getAttribute('data-swatch-image')
            if (img) return `background-image:url(${img});`
        }

        // Group the inputs and their corresponding attribute pairs
        const inputs = [
            { el: sportInput, key: 'sport' },
            { el: planetInput, key: 'planet' },
            { el: printInput, key: 'print' },
            { el: letterInput, key: 'letter' },
            { el: lineColorInput, key: 'line-color' }
        ]

        // Find the first input that exists and has a valid image attribute
        for (const { el, key } of inputs)
        {
            if (el)
            {
                const img = el.getAttribute(`data-${key}-image-80`) || el.getAttribute(`data-${key}-image-160`)
                if (img) return `background-image:url(${img});`
            }
        }

        return ''
    }

    function findMatchingVariantHighVariantMode() {
        const inputs = [
            activeColor(), activeSize(), activeSport(), activePlanet(),
            activePrint(), activeLetter(), activeLineColor(), activePump(),
            ...activeExtraInputs()
        ].filter(Boolean)

        for (const input of inputs)
        {
            const id = input.getAttribute('data-variant-id')
            if (!id) continue
            return {
                id: Number(id),
                price: Number(input.getAttribute('data-price')),
                compareAtPrice: Number(input.getAttribute('data-compare-at-price')) || null,
                available: input.getAttribute('data-available') !== 'false',
            }
        }
        return null
    }

    function findMatchingVariant() {
        if (highVariantMode) return findMatchingVariantHighVariantMode()
        if (!variants.length) return null

        // Define the configuration mapping for the options
        const checks = [
            { input: getActiveInput('color'), pos: colorPos },
            { input: getActiveInput('sport'), pos: sportPos },
            { input: getActiveInput('planet'), pos: planetPos },
            { input: getActiveInput('print'), pos: printPos },
            { input: getActiveInput('letter'), pos: letterPos },
            { input: getActiveInput('line-color'), pos: lineColorPos },
            { input: getActiveInput('pump'), pos: pumpPos },
            { input: getActiveInput('size'), pos: sizePos },
            ...activeExtraInputs().map((input) => ({ input, pos: extraPosFromInputName(input.name) }))
        ]

        return variants.find((v) => {
            // Look through each configuration check
            for (const { input, pos } of checks)
            {
                // If the input and position exist, ensure the variant option matches its value
                if (input && pos && v[`option${pos}`] !== input.value)
                {
                    return false
                }
            }
            return true // Found a match where all active options align
        }) || null
    }

    /* ── Qty stepper ─────────────────────────────────────────────────── */

    function updateQtyDisplay() {
        if (qtyValueEl) qtyValueEl.textContent = qty
        if (qtyMinusBtn) qtyMinusBtn.disabled = qty <= 1
        if (qtyPlusBtn) qtyPlusBtn.disabled = false
    }

    function updateAtcPrice() {
        if (!atcPriceEl) { renderSoldOut(); return }
        let cents = null
        let discountedCents = null

        if (bundle.length > 0)
        {
            cents = subtotal()
            const pct = discountPct()
            if (pct > 0) discountedCents = cents - Math.round(cents * pct)
        } else
        {
            const v = findMatchingVariant()
            if (v)
            {
                // TRADE PRICING (draft): B2B buyers see derived retail struck through.
                const vCompare = window.bsbTrade && window.bsbTrade.pct ? window.bsbTrade.compare(v.price, v.compareAtPrice) : v.compareAtPrice
                if (vCompare > v.price)
                {
                    cents = vCompare * qty
                    discountedCents = v.price * qty
                } else
                {
                    cents = v.price * qty
                }
            }
        }

        if (cents == null)
        {
            atcPriceEl.textContent = ''
        } else if (discountedCents != null)
        {
            atcPriceEl.innerHTML = ' – '
                + '<span class="bsb-pi__atc-price-original">' + formatPrice(cents) + '</span> '
                + '<span class="bsb-pi__atc-price-current">' + formatPrice(discountedCents) + '</span>'
        } else
        {
            atcPriceEl.textContent = ' – ' + formatPrice(cents)
        }
        renderSoldOut()
    }

    function bindQtyButtons() {
        if (qtyMinusBtn)
        {
            qtyMinusBtn.addEventListener('click', function () {
                if (qty > 1) { qty--; updateQtyDisplay(); updateAtcPrice() }
            })
        }

        if (qtyPlusBtn)
        {
            qtyPlusBtn.addEventListener('click', function () {
                qty++; updateQtyDisplay(); updateAtcPrice()
            })
        }
    }
    bindQtyButtons()

    /* ── Bundle mutation helpers ─────────────────────────────────────── */

    function currentSoldOut() {
        const v = findMatchingVariant()
        return !!v && v.available === false
    }

    function renderSoldOut() {
        const soldOut = currentSoldOut()
        if (addBtn) addBtn.disabled = soldOut
        if (!atcBtn) return
        const blocked = soldOut && bundle.length === 0
        if (atcLabelEl && !atcLabelEl.dataset.label) atcLabelEl.dataset.label = atcLabelEl.textContent.trim()
        atcBtn.disabled = blocked
        atcBtn.classList.toggle('bsb-pi__atc-btn--sold-out', blocked)
        if (atcLabelEl) atcLabelEl.textContent = blocked ? 'Sold out' : atcLabelEl.dataset.label
        if (blocked && atcPriceEl) atcPriceEl.textContent = ''
    }

    function addCurrentToBundle() {
        const variant = findMatchingVariant()
        if (!variant || variant.available === false) return
        const colorInput = activeColor()
        const sizeInput = activeSize()
        const sportInput = activeSport()
        const planetInput = activePlanet()
        const printInput = activePrint()
        const letterInput = activeLetter()
        const lineColorInput = activeLineColor()
        const colorLabel = colorInput ? (colorInput.getAttribute('data-color-name') || colorInput.value) : ''
        const sportLabel = sportInput ? sportInput.value : ''
        const planetLabel = planetInput ? planetInput.value : ''
        const printLabel = printInput ? printInput.value : ''
        const letterLabel = letterInput ? letterInput.value : ''
        const lineColorLabel = lineColorInput ? lineColorInput.value : ''
        const categoryLabel = sportLabel || planetLabel || printLabel || letterLabel || lineColorLabel
        const color = categoryLabel && colorLabel ? categoryLabel + ' · ' + colorLabel : categoryLabel || colorLabel
        const size = sizeInput ? sizeInput.value : ''
        const swatch = swatchStyleFor(colorInput, sportInput, planetInput, printInput, letterInput, lineColorInput)
        const existing = bundle.find((i) => i.variantId === variant.id)
        if (existing) { existing.qty += qty } else { bundle.push({ variantId: variant.id, color, size, qty, price: variant.price, compareAtPrice: variant.compareAtPrice, swatch }) }
        qty = 1
        render()
    }

    function removeFromBundle(variantId) {
        const idx = bundle.findIndex((i) => i.variantId === variantId)
        if (idx >= 0) { bundle.splice(idx, 1); render() }
    }

    function changeQty(variantId, delta) {
        const item = bundle.find((i) => i.variantId === variantId)
        if (!item) return
        item.qty = Math.max(1, item.qty + delta)
        render()
    }

    /* ── Add to bundle button ────────────────────────────────────────── */

    function bindAddButton() {
        if (addBtn)
        {
            addBtn.addEventListener('click', addCurrentToBundle)
        }
    }
    bindAddButton()

    /* ── Remove / qty change in bundle list (delegated) ─────────────── */

    function bindBundleList() {
        if (bundleListEl)
        {
            bundleListEl.addEventListener('click', function (e) {
                const btn = e.target.closest('button[data-action]')
                if (!btn) return
                const variantId = parseInt(btn.dataset.variantId, 10)
                if (!variantId) return
                if (btn.dataset.action === 'remove') removeFromBundle(variantId)
                else if (btn.dataset.action === 'inc') changeQty(variantId, 1)
                else if (btn.dataset.action === 'dec') changeQty(variantId, -1)
            })
        }
    }
    bindBundleList()

    /* ── Render ──────────────────────────────────────────────────────── */

    function renderBundleList() {
        if (!bundleListEl) return

        if (bundle.length === 0)
        {
            bundleListEl.innerHTML = ''
            return
        }

        bundleListEl.innerHTML = bundle.map((item) => {
            const swatchStyle = item.swatch || 'background:#f0f0f0;'
            const onSale = item.compareAtPrice > item.price
            const itemMeta = onSale
                ? '<span class="bsb-bc__item-price-compare">' + formatPrice(item.compareAtPrice) + '</span> ' + formatPrice(item.price) + ' ea'
                : formatPrice(item.price) + ' ea'
            return (
                '<li class="bsb-bc__item">' +
                '<span class="bsb-bc__item-swatch" style="' + swatchStyle + '" aria-hidden="true"></span>' +
                '<div class="bsb-bc__item-info">' +
                '<div class="bsb-bc__item-name">' + escapeHtml(item.color) + (item.size ? ' · ' + escapeHtml(item.size) : '') + '</div>' +
                '<div class="bsb-bc__item-meta">' + itemMeta + '</div>' +
                '</div>' +
                '<div class="bsb-bc__item-qty">' +
                '<button type="button" class="bsb-bc__item-qty-btn" data-action="dec" data-variant-id="' + item.variantId + '" aria-label="Decrease quantity" ' + (item.qty <= 1 ? 'disabled' : '') + '>−</button>' +
                '<span class="bsb-bc__item-qty-val">' + item.qty + '</span>' +
                '<button type="button" class="bsb-bc__item-qty-btn" data-action="inc" data-variant-id="' + item.variantId + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="bsb-bc__item-price">' + formatPrice(item.price * item.qty) + '</span>' +
                '<button type="button" class="bsb-bc__item-remove" data-action="remove" data-variant-id="' + item.variantId + '" aria-label="Remove ' + (item.size ? escapeHtml(item.size) + ' ' : '') + escapeHtml(item.color) + ' from bundle">✕</button>' +
                '</li>'
            )
        }).join('')
    }

    function renderTier() {
        if (!tierEl) return
        const n = totalBalls()

        tierEl.classList.toggle('bsb-bt--has-items', n > 0)

        /* Status row */
        const barMax = t2Pct > 0 ? t2Threshold : t1Threshold
        if (tierCountEl) tierCountEl.textContent = n + ' of ' + barMax + ' added'

        /* Next label */
        if (tierNextEl)
        {
            let msg = ''
            if (t2Pct > 0 && n >= t2Threshold)
            {
                msg = t2Unlocked.replace('{pct}', t2Pct)
            } else if (n >= t1Threshold)
            {
                if (t2Pct > 0)
                {
                    msg = t2Label.replace('{n}', t2Threshold - n).replace('{pct}', t2Pct)
                } else
                {
                    msg = t1Unlocked.replace('{pct}', t1Pct)
                }
            } else
            {
                msg = t1Label.replace('{n}', t1Threshold - n).replace('{pct}', t1Pct)
            }
            tierNextEl.textContent = msg
        }

        /* Progress bar fill */
        if (tierFillEl)
        {
            const fillPct = Math.min(n / barMax, 1) * 100
            tierFillEl.style.width = fillPct + '%'
        }

        /* Track aria */
        if (tierTrackEl) tierTrackEl.setAttribute('aria-valuenow', n)

        /* Marker hit states */
        if (tierEl)
        {
            const minThreshold = parseInt(tierEl.dataset.bundleMin, 10) || bundleMin
            tierEl.querySelector('.bsb-bt__marker--min')
                ?.classList.toggle('bsb-bt__marker--hit', n >= minThreshold)
            tierEl.querySelector('.bsb-bt__marker-label--min')
                ?.classList.toggle('bsb-bt__marker-label--hit', n >= minThreshold)
            tierEl.querySelector('.bsb-bt__marker--tier1')
                ?.classList.toggle('bsb-bt__marker--hit', n >= t1Threshold)
            tierEl.querySelector('.bsb-bt__marker-label--tier1')
                ?.classList.toggle('bsb-bt__marker-label--hit', n >= t1Threshold)
            if (t2Pct > 0)
            {
                tierEl.querySelector('.bsb-bt__marker--tier2')
                    ?.classList.toggle('bsb-bt__marker--hit', n >= t2Threshold)
                tierEl.querySelector('.bsb-bt__marker-label--tier2')
                    ?.classList.toggle('bsb-bt__marker-label--hit', n >= t2Threshold)
            }
        }
    }

    function renderTotals() {
        const n = totalBalls()
        const sub = subtotal()
        const pct = discountPct()
        const disc = Math.round(sub * pct)
        const tot = sub - disc

        if (totalsEl)
        {
            if (n === 0)
            {
                totalsEl.setAttribute('hidden', '')
            } else
            {
                totalsEl.removeAttribute('hidden')
            }
        }

        if (totalEl) totalEl.textContent = formatPrice(tot)
        totalEl?.closest('.bsb-bc__totals-row--total')?.classList.toggle('bsb-bc__totals-row--total--sep', pct > 0)

        if (pct > 0)
        {
            if (subtotalEl) subtotalEl.textContent = formatPrice(sub)
            if (subtotalEl) subtotalEl.closest('.bsb-bc__totals-row')?.removeAttribute('hidden')
            if (discountRowEl)
            {
                discountRowEl.removeAttribute('hidden')
                if (discountLblEl) discountLblEl.textContent = 'Bundle discount (' + (pct * 100) + '% off)'
                if (discountValEl) discountValEl.textContent = '−' + formatPrice(disc)
            }
        } else
        {
            if (subtotalEl) subtotalEl.closest('.bsb-bc__totals-row')?.setAttribute('hidden', '')
            if (discountRowEl) discountRowEl.setAttribute('hidden', '')
        }
    }

    function renderBundleCount() {
        if (!bundleCountEl) return
        const n = totalBalls()
        bundleCountEl.textContent = n === 0 ? 'Empty' : n + ' ball' + (n === 1 ? '' : 's')
    }

    function renderAddBtnLabel() {
        if (!addBtn) return
        const labels = tierEl ? tierEl.dataset : {}
        addBtn.textContent = bundle.length > 0
            ? (labels.btnMore || 'Add to bundle')
            : (labels.btnStart || 'Start a bundle')
    }

    function maybeBurstConfetti() {
        const pct = discountPct()
        if (pct <= prevDiscountPct) { prevDiscountPct = pct; return }
        prevDiscountPct = pct
        if (typeof window.bsbConfetti !== 'function') return
        const count = pct >= (t2Pct / 100) && t2Pct > 0 ? 120 : 80
        const origin = atcBtn || document.getElementById('bsb-bundle-atc')
        if (origin)
        {
            const rect = origin.getBoundingClientRect()
            window.bsbConfetti(count, rect.left + rect.width / 2, rect.top + rect.height / 2)
        } else
        {
            window.bsbConfetti(count)
        }
    }

    function render() {
        renderBundleList()
        renderTier()
        renderTotals()
        renderBundleCount()
        renderAddBtnLabel()
        updateQtyDisplay()
        updateAtcPrice()
        maybeBurstConfetti()
        if (typeof window.bsbOnCartChange === 'function') window.bsbOnCartChange(bundle.slice())
    }

    /* ── Color / size change handlers ────────────────────────────────── */

    function updateSizeTooltip(input) {
        if (!tipEl) return
        const height = input.getAttribute('data-tooltip-height')
        const best = input.getAttribute('data-tooltip-best-for')
        if (height || best)
        {
            if (tipTitleEl) tipTitleEl.textContent = height || ''
            if (tipBestEl) tipBestEl.textContent = best || ''
            tipEl.classList.add('is-visible')
        } else
        {
            tipEl.classList.remove('is-visible')
        }
    }

    function updateSizePrices(optionInput) {
        if (typeof window.bsbUpdateSizePrices === 'function') window.bsbUpdateSizePrices(optionInput)
    }

    document.addEventListener('change', function (e) {
        const input = e.target
        if (input.name === 'bsb-color')
        {
            if (colorNameEl) colorNameEl.textContent = input.getAttribute('data-color-name') || input.value
            updateSizePrices(input)
            if (typeof window.bsbLgSyncColor === 'function') window.bsbLgSyncColor(input.value)
        }
        if (input.name === 'bsb-size')
        {
            if (sizeNameEl) sizeNameEl.textContent = input.value
            updateSizeTooltip(input)
        }
        if (input.name === 'bsb-sport')
        {
            const sportNameEl = document.getElementById('bsb-sport-name')
            if (sportNameEl) sportNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name === 'bsb-planet')
        {
            const planetNameEl = document.getElementById('bsb-planet-name')
            if (planetNameEl) planetNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name === 'bsb-print')
        {
            const printNameEl = document.getElementById('bsb-print-name')
            if (printNameEl) printNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name === 'bsb-letter')
        {
            const letterNameEl = document.getElementById('bsb-letter-name')
            if (letterNameEl) letterNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name === 'bsb-line-color')
        {
            const lineColorNameEl = document.getElementById('bsb-line-color-name')
            if (lineColorNameEl) lineColorNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name === 'bsb-pump')
        {
            const pumpNameEl = document.getElementById('bsb-pump-name')
            if (pumpNameEl) pumpNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name.indexOf('bsb-opt-') === 0)
        {
            const extraNameEl = document.getElementById(input.name + '-name')
            if (extraNameEl) extraNameEl.textContent = input.value
            updateSizePrices(input)
        }
        if (input.name === 'bsb-color' || input.name === 'bsb-size' || input.name === 'bsb-sport' || input.name === 'bsb-planet' || input.name === 'bsb-print' || input.name === 'bsb-letter' || input.name === 'bsb-line-color' || input.name === 'bsb-pump' || input.name.indexOf('bsb-opt-') === 0)
        {
            updateAtcPrice()
        }
    })

    /* Tooltip for pre-selected size on load */
    const initialSize = activeSize()
    if (initialSize) updateSizeTooltip(initialSize)

    /* Swatch image preload on hover */
    document.querySelectorAll('label[for^="bsb-color-"]').forEach((label) => {
        label.addEventListener('pointerenter', function () {
            const input = document.getElementById(label.htmlFor)
            if (!input || input.dataset.ballImgPreloaded) return
            input.dataset.ballImgPreloaded = '1'
            BALL_WIDTHS.forEach((w) => {
                const url = input.getAttribute('data-ball-image-' + w)
                if (!url) return
                const link = document.createElement('link')
                link.rel = 'preload'
                link.as = 'image'
                link.href = url
                document.head.appendChild(link)
            })
        }, { passive: true })
    })

    /* ── Popular presets ─────────────────────────────────────────────── */

    /* Stamp prices onto preset cards on load; cache parsed items on the element */
    document.querySelectorAll('[data-preset-items]').forEach(function (card) {
        let items
        try { items = JSON.parse(card.dataset.presetItems) } catch (_) { return }
        if (!Array.isArray(items) || items.length === 0) return

        card._presetItems = items

        let totalCents = 0
        let compareCents = 0
        items.forEach(function (item) {
            const variant = variants.find((v) => v.id === item.variantId)
            if (!variant) return
            const qty = item.qty || 1
            totalCents += variant.price * qty
            compareCents += (variant.compareAtPrice > variant.price ? variant.compareAtPrice : variant.price) * qty
        })

        if (compareCents > totalCents)
        {
            const compareEl = document.createElement('span')
            compareEl.className = 'bsb-bpr__price-compare'
            compareEl.textContent = formatPrice(compareCents)
            card.appendChild(compareEl)
        }

        const priceEl = document.createElement('span')
        priceEl.className = 'bsb-bpr__price'
        priceEl.textContent = formatPrice(totalCents)
        card.appendChild(priceEl)
    })

    document.addEventListener('click', function (e) {
        const card = e.target.closest('[data-preset-items]')
        if (!card) return

        const items = card._presetItems
        if (!Array.isArray(items) || items.length === 0) return

        bundle.length = 0

        items.forEach(function (item) {
            const variant = variants.find((v) => v.id === item.variantId)
            if (!variant) return

            const colorOpt = colorPos ? variant['option' + colorPos] : ''
            const sizeOpt = sizePos ? variant['option' + sizePos] : ''
            const sportOpt = sportPos ? variant['option' + sportPos] : ''
            const planetOpt = planetPos ? variant['option' + planetPos] : ''
            const printOpt = printPos ? variant['option' + printPos] : ''
            const letterOpt = letterPos ? variant['option' + letterPos] : ''
            const lineColorOpt = lineColorPos ? variant['option' + lineColorPos] : ''

            const colorInput = document.querySelector('input[name="bsb-color"][value=' + JSON.stringify(colorOpt) + ']')
            const sportInput = document.querySelector('input[name="bsb-sport"][value=' + JSON.stringify(sportOpt) + ']')
            const planetInput = document.querySelector('input[name="bsb-planet"][value=' + JSON.stringify(planetOpt) + ']')
            const printInput = document.querySelector('input[name="bsb-print"][value=' + JSON.stringify(printOpt) + ']')
            const letterInput = document.querySelector('input[name="bsb-letter"][value=' + JSON.stringify(letterOpt) + ']')
            const lineColorInput = document.querySelector('input[name="bsb-line-color"][value=' + JSON.stringify(lineColorOpt) + ']')
            const swatch = swatchStyleFor(colorInput, sportInput, planetInput, printInput, letterInput, lineColorInput)

            bundle.push({
                variantId: variant.id,
                color: colorOpt,
                size: sizeOpt,
                qty: item.qty || 1,
                price: variant.price,
                compareAtPrice: variant.compareAtPrice,
                swatch,
            })
        })

        qty = 1
        render()

        /* Scroll the bundle list into view */
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        if (bundleListEl) bundleListEl.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' })
    })

    /* ── ATC — submit bundle to Shopify cart ─────────────────────────── */

    function refreshCartCountBubble() {
        const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root + 'cart.js'
            : '/cart.js'
        fetch(cartUrl).then((r) => r.json()).then((c) => {
            document
                .querySelectorAll('.cart-count-bubble span, .icon-cart-ball__count')
                .forEach((el) => { el.textContent = c.item_count })
        }).catch(() => { })
    }

    let _atcCallback = null

    function bindAtcButton() {
        if (!atcBtn) return
        atcBtn.addEventListener('click', function () {
            const lineItems = bundle.length > 0
                ? bundle.map((i) => ({ id: i.variantId, quantity: i.qty }))
                : (() => { const v = findMatchingVariant(); return v && v.available !== false ? [{ id: v.id, quantity: qty }] : [] })()

            if (lineItems.length === 0) return
            const pumpCheck = document.getElementById('bsb-pump-check')
            if (pumpCheck && pumpCheck.checked) {
                const pumpId = parseInt(pumpCheck.getAttribute('data-variant-id'), 10)
                if (pumpId) lineItems.push({ id: pumpId, quantity: 1 })
            }
            const originalText = atcLabelEl ? atcLabelEl.textContent.trim() : atcBtn.textContent.trim()
            atcBtn.disabled = true
            if (atcLabelEl) atcLabelEl.textContent = 'Adding…'; else atcBtn.textContent = 'Adding…'

            const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                ? window.Shopify.routes.root + 'cart/add.js'
                : '/cart/add.js'

            const body = { items: lineItems }

            fetch(cartAddUrl, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then((res) => res.json().then((d) => ({ ok: res.ok, d })))
                .then(({ ok, d }) => {
                    if (!ok) throw new Error((d && d.description) || 'Cart add failed')
                    if (atcLabelEl) atcLabelEl.textContent = '✓ Added to cart'; else atcBtn.textContent = '✓ Added to cart'

                    const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                        ? window.Shopify.routes.root + 'cart.js'
                        : '/cart.js'
                    fetch(cartUrl).then((r) => r.json()).then((cart) => {
                        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }))
                    }).catch(() => {})
                    const cb = _atcCallback; _atcCallback = null
                    if (typeof cb === 'function') cb(true)
                    setTimeout(() => {
                        bundle.length = 0
                        qty = 1
                        prevDiscountPct = 0
                        render()
                        atcBtn.disabled = false
                        if (atcLabelEl) atcLabelEl.textContent = originalText; else atcBtn.textContent = originalText
                    }, 1500)
                    refreshCartCountBubble()
                })
                .catch((err) => {
                    console.warn('[bsb-bb] Cart submission failed:', err)
                    const cb = _atcCallback; _atcCallback = null
                    if (typeof cb === 'function') cb(false)
                    if (atcLabelEl) atcLabelEl.textContent = 'Try again'; else atcBtn.textContent = 'Try again'
                    setTimeout(() => {
                        atcBtn.disabled = false
                        if (atcLabelEl) atcLabelEl.textContent = originalText; else atcBtn.textContent = originalText
                    }, 1800)
                })
        })
    }
    bindAtcButton()

    /* ── Expose globals for sticky bar ──────────────────────────────── */

    window.bsbGetBundle = () => bundle.slice()
    window.bsbIsSoldOut = () => bundle.length === 0 && currentSoldOut()
    window.bsbCurrentSoldOut = currentSoldOut
    window.bsbDiscountPct = discountPct

    /* Override bsb-product-info.js globals — bundle mode owns the cart */
    window.bsbAddToBundle = addCurrentToBundle
    window.bsbRemoveFromBundle = removeFromBundle
    window.bsbChangeQty = changeQty
    window.bsbSubmitCart = function (callback) {
        if (typeof callback === 'function') _atcCallback = callback
        if (atcBtn) atcBtn.click()
    }

    /* ── Init ────────────────────────────────────────────────────────── */

    render()

})()
